/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "statement/models.proto" (package "rd.statement", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Money } from "../proto/money/models_pb";
import { Contacts_Contact } from "../customer/models_pb";
import { Customer } from "../customer/models_pb";
import { Location } from "../company/models_pb";
import { Company } from "../company/models_pb";
import { CustomerBalance } from "../txn/models_pb";
import { User } from "../user/models_pb";
import { Timestamp } from "../google/protobuf/timestamp_pb";
import { UUID } from "../proto/uuid/models_pb";
/**
 * StatementRun represents statements sent out by suppliers to customers
 * regarding any outstanding balances on previous transactions.
 *
 * @generated from protobuf message rd.statement.StatementRun
 */
export interface StatementRun {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp emailed_at = 5
     */
    emailedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp mailed_at = 6
     */
    mailedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User emailed_by = 7
     */
    emailedBy?: User;
    /**
     * @generated from protobuf field: rd.user.User mailed_by = 8
     */
    mailedBy?: User;
    /**
     * @generated from protobuf field: rd.statement.StatementRun.RunType run_type = 9
     */
    runType: StatementRun_RunType;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_date = 10
     */
    startDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_date = 11
     */
    endDate?: Timestamp;
    /**
     * @generated from protobuf field: rd.statement.StatementRun.PDFGenerationStatus pdf_generation_status = 13
     */
    pdfGenerationStatus: StatementRun_PDFGenerationStatus;
}
/**
 * @generated from protobuf enum rd.statement.StatementRun.RunType
 */
export enum StatementRun_RunType {
    /**
     * @generated from protobuf enum value: RUN_TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: RUN_TYPE_AUTOMATIC = 1;
     */
    AUTOMATIC = 1,
    /**
     * @generated from protobuf enum value: RUN_TYPE_MANUAL = 2;
     */
    MANUAL = 2
}
/**
 * @generated from protobuf enum rd.statement.StatementRun.PDFGenerationStatus
 */
export enum StatementRun_PDFGenerationStatus {
    /**
     * @generated from protobuf enum value: PDF_GENERATION_STATUS_UNDEFINED = 0;
     */
    PDF_GENERATION_STATUS_UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: PDF_GENERATION_STATUS_INITIATED = 1;
     */
    PDF_GENERATION_STATUS_INITIATED = 1,
    /**
     * @generated from protobuf enum value: PDF_GENERATION_STATUS_COMPLETED = 2;
     */
    PDF_GENERATION_STATUS_COMPLETED = 2,
    /**
     * @generated from protobuf enum value: PDF_GENERATION_STATUS_ERROR = 3;
     */
    PDF_GENERATION_STATUS_ERROR = 3
}
/**
 * Statement represents a customer statement with a link to the storage bucket
 * at a snapshot in time.
 *
 * @generated from protobuf message rd.statement.Statement
 */
export interface Statement {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 4
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID statement_run_id = 5
     */
    statementRunId?: UUID;
    /**
     * @generated from protobuf field: string url = 6
     */
    url: string;
    /**
     * @generated from protobuf field: rd.txn.CustomerBalance customer_balance = 7
     */
    customerBalance?: CustomerBalance;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 8
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.statement.Statement.Status status = 9
     */
    status: Statement_Status;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp initiated_at = 10
     */
    initiatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 11
     */
    completedAt?: Timestamp;
    /**
     * @generated from protobuf field: bool should_generate_statement_pdf = 12
     */
    shouldGenerateStatementPdf: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_date = 13
     */
    endDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp mailed_at = 14
     */
    mailedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp emailed_at = 15
     */
    emailedAt?: Timestamp;
    /**
     * @generated from protobuf field: string internal_error_message = 16
     */
    internalErrorMessage: string;
    /**
     * @generated from protobuf field: rd.statement.Statement.AutopayStatus autopay_status = 17
     */
    autopayStatus: Statement_AutopayStatus;
    /**
     * @generated from protobuf field: string autopay_error_message = 18
     */
    autopayErrorMessage: string;
    /**
     * only present on statements generated after 2026-07-01
     *
     * @generated from protobuf field: rd.proto.uuid.UUID bill_payment_id = 19
     */
    billPaymentId?: UUID;
    /**
     * only present on statements generated after 2026-07-01
     *
     * @generated from protobuf field: rd.proto.uuid.UUID finance_charge_ledger_entry_id = 20
     */
    financeChargeLedgerEntryId?: UUID;
}
/**
 * @generated from protobuf enum rd.statement.Statement.Status
 */
export enum Statement_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATUS_INITIATED = 1;
     */
    INITIATED = 1,
    /**
     * @generated from protobuf enum value: STATUS_COMPLETED = 2;
     */
    COMPLETED = 2,
    /**
     * @generated from protobuf enum value: STATUS_ERROR = 3;
     */
    ERROR = 3
}
/**
 * @generated from protobuf enum rd.statement.Statement.AutopayStatus
 */
export enum Statement_AutopayStatus {
    /**
     * @generated from protobuf enum value: AUTOPAY_STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: AUTOPAY_STATUS_SUCCESS = 1;
     */
    SUCCESS = 1,
    /**
     * @generated from protobuf enum value: AUTOPAY_STATUS_NO_PRIMARY_PAYMENT_METHOD = 2;
     */
    NO_PRIMARY_PAYMENT_METHOD = 2,
    /**
     * @generated from protobuf enum value: AUTOPAY_STATUS_PAYMENT_DECLINED = 3;
     */
    PAYMENT_DECLINED = 3,
    /**
     * @generated from protobuf enum value: AUTOPAY_STATUS_SERIALIZATION_ISSUE = 4;
     */
    SERIALIZATION_ISSUE = 4,
    /**
     * @generated from protobuf enum value: AUTOPAY_STATUS_ASK_SUPPORT = 5;
     */
    ASK_SUPPORT = 5
}
/**
 * StatementSummaryData represents the data required to fill the html
 * template for a statement summary page
 *
 * @generated from protobuf message rd.statement.StatementSummaryData
 */
export interface StatementSummaryData {
    /**
     * @generated from protobuf field: string identifier = 1
     */
    identifier: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp statement_date = 2
     */
    statementDate?: Timestamp;
    /**
     * @generated from protobuf field: rd.company.Company company = 3
     */
    company?: Company;
    /**
     * @generated from protobuf field: rd.company.Location location = 4
     */
    location?: Location;
    /**
     * @generated from protobuf field: rd.customer.Customer customer = 5
     */
    customer?: Customer;
    /**
     * @generated from protobuf field: rd.customer.Contacts.Contact primary_contact = 6
     */
    primaryContact?: Contacts_Contact;
    /**
     * @generated from protobuf field: rd.txn.CustomerBalance customer_balance = 7
     */
    customerBalance?: CustomerBalance;
    /**
     * @generated from protobuf field: string statement_message = 8
     */
    statementMessage: string;
    /**
     * @generated from protobuf field: repeated rd.statement.StatementSummaryData.Activity activities = 9
     */
    activities: StatementSummaryData_Activity[];
    /**
     * @generated from protobuf field: repeated rd.statement.StatementSummaryData.OutstandingInvoice outstanding_invoices = 10
     */
    outstandingInvoices: StatementSummaryData_OutstandingInvoice[];
}
/**
 * Data to populate rows in the "All Activity" table
 *
 * @generated from protobuf message rd.statement.StatementSummaryData.Activity
 */
export interface StatementSummaryData_Activity {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp date = 1
     */
    date?: Timestamp;
    /**
     * relevant types: PURCHASE, PAYMENT, RETURN, REFUND, FINANCING_CHARGE, WRITE_OFF
     *
     * @generated from protobuf field: string transaction_type = 2
     */
    transactionType: string;
    /**
     * @generated from protobuf field: string identifier = 3
     */
    identifier: string;
    /**
     * @generated from protobuf field: string purchase_order_name = 4
     */
    purchaseOrderName: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money charge_amount = 5
     */
    chargeAmount?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money credit_amount = 6
     */
    creditAmount?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money outstanding_balance = 7
     */
    outstandingBalance?: Money;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp due_date = 8
     */
    dueDate?: Timestamp;
    /**
     * @generated from protobuf field: string job_name = 9
     */
    jobName: string;
}
/**
 * Data to populate rows in the "Outstanding invoices" table
 *
 * @generated from protobuf message rd.statement.StatementSummaryData.OutstandingInvoice
 */
export interface StatementSummaryData_OutstandingInvoice {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp date = 1
     */
    date?: Timestamp;
    /**
     * @generated from protobuf field: string purchase_order_name = 3
     */
    purchaseOrderName: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money outstanding_balance = 4
     */
    outstandingBalance?: Money;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp due_date = 5
     */
    dueDate?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money original_balance = 6
     */
    originalBalance?: Money;
    /**
     * @generated from protobuf field: string job_name = 7
     */
    jobName: string;
    /**
     * @generated from protobuf field: repeated rd.statement.StatementSummaryData.OutstandingInvoice.AssociatedPayment associated_payments = 8
     */
    associatedPayments: StatementSummaryData_OutstandingInvoice_AssociatedPayment[];
    /**
     * @generated from protobuf field: string transaction_type = 9
     */
    transactionType: string;
    /**
     * @generated from protobuf field: string identifier = 10
     */
    identifier: string;
}
/**
 * @generated from protobuf message rd.statement.StatementSummaryData.OutstandingInvoice.AssociatedPayment
 */
export interface StatementSummaryData_OutstandingInvoice_AssociatedPayment {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp date = 1
     */
    date?: Timestamp;
    /**
     * @generated from protobuf field: string identifier = 2
     */
    identifier: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money amount = 3
     */
    amount?: Money;
    /**
     * @generated from protobuf field: string transaction_type = 4
     */
    transactionType: string;
}
/**
 * StatementType represents the type of statement being generated.
 *
 * @generated from protobuf enum rd.statement.StatementType
 */
export enum StatementType {
    /**
     * @generated from protobuf enum value: STATEMENT_TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATEMENT_TYPE_OPEN_ITEM = 1;
     */
    OPEN_ITEM = 1,
    /**
     * @generated from protobuf enum value: STATEMENT_TYPE_BALANCE_FORWARD = 2;
     */
    BALANCE_FORWARD = 2
}
/**
 * StatementInvoicesFormatType represents the format of the invoices attached to the statement.
 *
 * @generated from protobuf enum rd.statement.StatementInvoicesFormatType
 */
export enum StatementInvoicesFormatType {
    /**
     * @generated from protobuf enum value: STATEMENT_INVOICES_FORMAT_TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATEMENT_INVOICES_FORMAT_TYPE_NONE = 1;
     */
    NONE = 1,
    /**
     * @generated from protobuf enum value: STATEMENT_INVOICES_FORMAT_TYPE_CONDENSED = 2;
     */
    CONDENSED = 2,
    /**
     * @generated from protobuf enum value: STATEMENT_INVOICES_FORMAT_TYPE_FULL_PAGE = 3;
     */
    FULL_PAGE = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class StatementRun$Type extends MessageType<StatementRun> {
    constructor() {
        super("rd.statement.StatementRun", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "emailed_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "mailed_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "emailed_by", kind: "message", T: () => User },
            { no: 8, name: "mailed_by", kind: "message", T: () => User },
            { no: 9, name: "run_type", kind: "enum", T: () => ["rd.statement.StatementRun.RunType", StatementRun_RunType, "RUN_TYPE_"] },
            { no: 10, name: "start_date", kind: "message", T: () => Timestamp },
            { no: 11, name: "end_date", kind: "message", T: () => Timestamp },
            { no: 13, name: "pdf_generation_status", kind: "enum", T: () => ["rd.statement.StatementRun.PDFGenerationStatus", StatementRun_PDFGenerationStatus] }
        ]);
    }
    create(value?: PartialMessage<StatementRun>): StatementRun {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.runType = 0;
        message.pdfGenerationStatus = 0;
        if (value !== undefined)
            reflectionMergePartial<StatementRun>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StatementRun): StatementRun {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* google.protobuf.Timestamp emailed_at */ 5:
                    message.emailedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.emailedAt);
                    break;
                case /* google.protobuf.Timestamp mailed_at */ 6:
                    message.mailedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.mailedAt);
                    break;
                case /* rd.user.User emailed_by */ 7:
                    message.emailedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.emailedBy);
                    break;
                case /* rd.user.User mailed_by */ 8:
                    message.mailedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.mailedBy);
                    break;
                case /* rd.statement.StatementRun.RunType run_type */ 9:
                    message.runType = reader.int32();
                    break;
                case /* google.protobuf.Timestamp start_date */ 10:
                    message.startDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startDate);
                    break;
                case /* google.protobuf.Timestamp end_date */ 11:
                    message.endDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.endDate);
                    break;
                case /* rd.statement.StatementRun.PDFGenerationStatus pdf_generation_status */ 13:
                    message.pdfGenerationStatus = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StatementRun, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp emailed_at = 5; */
        if (message.emailedAt)
            Timestamp.internalBinaryWrite(message.emailedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp mailed_at = 6; */
        if (message.mailedAt)
            Timestamp.internalBinaryWrite(message.mailedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User emailed_by = 7; */
        if (message.emailedBy)
            User.internalBinaryWrite(message.emailedBy, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User mailed_by = 8; */
        if (message.mailedBy)
            User.internalBinaryWrite(message.mailedBy, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.statement.StatementRun.RunType run_type = 9; */
        if (message.runType !== 0)
            writer.tag(9, WireType.Varint).int32(message.runType);
        /* google.protobuf.Timestamp start_date = 10; */
        if (message.startDate)
            Timestamp.internalBinaryWrite(message.startDate, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp end_date = 11; */
        if (message.endDate)
            Timestamp.internalBinaryWrite(message.endDate, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.statement.StatementRun.PDFGenerationStatus pdf_generation_status = 13; */
        if (message.pdfGenerationStatus !== 0)
            writer.tag(13, WireType.Varint).int32(message.pdfGenerationStatus);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.statement.StatementRun
 */
export const StatementRun = new StatementRun$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Statement$Type extends MessageType<Statement> {
    constructor() {
        super("rd.statement.Statement", [
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "customer_id", kind: "message", T: () => UUID },
            { no: 5, name: "statement_run_id", kind: "message", T: () => UUID },
            { no: 6, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "customer_balance", kind: "message", T: () => CustomerBalance },
            { no: 8, name: "company_id", kind: "message", T: () => UUID },
            { no: 9, name: "status", kind: "enum", T: () => ["rd.statement.Statement.Status", Statement_Status, "STATUS_"] },
            { no: 10, name: "initiated_at", kind: "message", T: () => Timestamp },
            { no: 11, name: "completed_at", kind: "message", T: () => Timestamp },
            { no: 12, name: "should_generate_statement_pdf", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "end_date", kind: "message", T: () => Timestamp },
            { no: 14, name: "mailed_at", kind: "message", T: () => Timestamp },
            { no: 15, name: "emailed_at", kind: "message", T: () => Timestamp },
            { no: 16, name: "internal_error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "autopay_status", kind: "enum", T: () => ["rd.statement.Statement.AutopayStatus", Statement_AutopayStatus, "AUTOPAY_STATUS_"] },
            { no: 18, name: "autopay_error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "bill_payment_id", kind: "message", T: () => UUID },
            { no: 20, name: "finance_charge_ledger_entry_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<Statement>): Statement {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.url = "";
        message.status = 0;
        message.shouldGenerateStatementPdf = false;
        message.internalErrorMessage = "";
        message.autopayStatus = 0;
        message.autopayErrorMessage = "";
        if (value !== undefined)
            reflectionMergePartial<Statement>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Statement): Statement {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 4:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.uuid.UUID statement_run_id */ 5:
                    message.statementRunId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.statementRunId);
                    break;
                case /* string url */ 6:
                    message.url = reader.string();
                    break;
                case /* rd.txn.CustomerBalance customer_balance */ 7:
                    message.customerBalance = CustomerBalance.internalBinaryRead(reader, reader.uint32(), options, message.customerBalance);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 8:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.statement.Statement.Status status */ 9:
                    message.status = reader.int32();
                    break;
                case /* google.protobuf.Timestamp initiated_at */ 10:
                    message.initiatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.initiatedAt);
                    break;
                case /* google.protobuf.Timestamp completed_at */ 11:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                case /* bool should_generate_statement_pdf */ 12:
                    message.shouldGenerateStatementPdf = reader.bool();
                    break;
                case /* google.protobuf.Timestamp end_date */ 13:
                    message.endDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.endDate);
                    break;
                case /* google.protobuf.Timestamp mailed_at */ 14:
                    message.mailedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.mailedAt);
                    break;
                case /* google.protobuf.Timestamp emailed_at */ 15:
                    message.emailedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.emailedAt);
                    break;
                case /* string internal_error_message */ 16:
                    message.internalErrorMessage = reader.string();
                    break;
                case /* rd.statement.Statement.AutopayStatus autopay_status */ 17:
                    message.autopayStatus = reader.int32();
                    break;
                case /* string autopay_error_message */ 18:
                    message.autopayErrorMessage = reader.string();
                    break;
                case /* rd.proto.uuid.UUID bill_payment_id */ 19:
                    message.billPaymentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.billPaymentId);
                    break;
                case /* rd.proto.uuid.UUID finance_charge_ledger_entry_id */ 20:
                    message.financeChargeLedgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.financeChargeLedgerEntryId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Statement, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 4; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID statement_run_id = 5; */
        if (message.statementRunId)
            UUID.internalBinaryWrite(message.statementRunId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string url = 6; */
        if (message.url !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.url);
        /* rd.txn.CustomerBalance customer_balance = 7; */
        if (message.customerBalance)
            CustomerBalance.internalBinaryWrite(message.customerBalance, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 8; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.statement.Statement.Status status = 9; */
        if (message.status !== 0)
            writer.tag(9, WireType.Varint).int32(message.status);
        /* google.protobuf.Timestamp initiated_at = 10; */
        if (message.initiatedAt)
            Timestamp.internalBinaryWrite(message.initiatedAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp completed_at = 11; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* bool should_generate_statement_pdf = 12; */
        if (message.shouldGenerateStatementPdf !== false)
            writer.tag(12, WireType.Varint).bool(message.shouldGenerateStatementPdf);
        /* google.protobuf.Timestamp end_date = 13; */
        if (message.endDate)
            Timestamp.internalBinaryWrite(message.endDate, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp mailed_at = 14; */
        if (message.mailedAt)
            Timestamp.internalBinaryWrite(message.mailedAt, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp emailed_at = 15; */
        if (message.emailedAt)
            Timestamp.internalBinaryWrite(message.emailedAt, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* string internal_error_message = 16; */
        if (message.internalErrorMessage !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.internalErrorMessage);
        /* rd.statement.Statement.AutopayStatus autopay_status = 17; */
        if (message.autopayStatus !== 0)
            writer.tag(17, WireType.Varint).int32(message.autopayStatus);
        /* string autopay_error_message = 18; */
        if (message.autopayErrorMessage !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.autopayErrorMessage);
        /* rd.proto.uuid.UUID bill_payment_id = 19; */
        if (message.billPaymentId)
            UUID.internalBinaryWrite(message.billPaymentId, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID finance_charge_ledger_entry_id = 20; */
        if (message.financeChargeLedgerEntryId)
            UUID.internalBinaryWrite(message.financeChargeLedgerEntryId, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.statement.Statement
 */
export const Statement = new Statement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StatementSummaryData$Type extends MessageType<StatementSummaryData> {
    constructor() {
        super("rd.statement.StatementSummaryData", [
            { no: 1, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "statement_date", kind: "message", T: () => Timestamp },
            { no: 3, name: "company", kind: "message", T: () => Company },
            { no: 4, name: "location", kind: "message", T: () => Location },
            { no: 5, name: "customer", kind: "message", T: () => Customer },
            { no: 6, name: "primary_contact", kind: "message", T: () => Contacts_Contact },
            { no: 7, name: "customer_balance", kind: "message", T: () => CustomerBalance },
            { no: 8, name: "statement_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "activities", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => StatementSummaryData_Activity },
            { no: 10, name: "outstanding_invoices", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => StatementSummaryData_OutstandingInvoice }
        ]);
    }
    create(value?: PartialMessage<StatementSummaryData>): StatementSummaryData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.statementMessage = "";
        message.activities = [];
        message.outstandingInvoices = [];
        if (value !== undefined)
            reflectionMergePartial<StatementSummaryData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StatementSummaryData): StatementSummaryData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string identifier */ 1:
                    message.identifier = reader.string();
                    break;
                case /* google.protobuf.Timestamp statement_date */ 2:
                    message.statementDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.statementDate);
                    break;
                case /* rd.company.Company company */ 3:
                    message.company = Company.internalBinaryRead(reader, reader.uint32(), options, message.company);
                    break;
                case /* rd.company.Location location */ 4:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.customer.Customer customer */ 5:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* rd.customer.Contacts.Contact primary_contact */ 6:
                    message.primaryContact = Contacts_Contact.internalBinaryRead(reader, reader.uint32(), options, message.primaryContact);
                    break;
                case /* rd.txn.CustomerBalance customer_balance */ 7:
                    message.customerBalance = CustomerBalance.internalBinaryRead(reader, reader.uint32(), options, message.customerBalance);
                    break;
                case /* string statement_message */ 8:
                    message.statementMessage = reader.string();
                    break;
                case /* repeated rd.statement.StatementSummaryData.Activity activities */ 9:
                    message.activities.push(StatementSummaryData_Activity.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.statement.StatementSummaryData.OutstandingInvoice outstanding_invoices */ 10:
                    message.outstandingInvoices.push(StatementSummaryData_OutstandingInvoice.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StatementSummaryData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string identifier = 1; */
        if (message.identifier !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier);
        /* google.protobuf.Timestamp statement_date = 2; */
        if (message.statementDate)
            Timestamp.internalBinaryWrite(message.statementDate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Company company = 3; */
        if (message.company)
            Company.internalBinaryWrite(message.company, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 4; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer customer = 5; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Contacts.Contact primary_contact = 6; */
        if (message.primaryContact)
            Contacts_Contact.internalBinaryWrite(message.primaryContact, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.CustomerBalance customer_balance = 7; */
        if (message.customerBalance)
            CustomerBalance.internalBinaryWrite(message.customerBalance, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string statement_message = 8; */
        if (message.statementMessage !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.statementMessage);
        /* repeated rd.statement.StatementSummaryData.Activity activities = 9; */
        for (let i = 0; i < message.activities.length; i++)
            StatementSummaryData_Activity.internalBinaryWrite(message.activities[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.statement.StatementSummaryData.OutstandingInvoice outstanding_invoices = 10; */
        for (let i = 0; i < message.outstandingInvoices.length; i++)
            StatementSummaryData_OutstandingInvoice.internalBinaryWrite(message.outstandingInvoices[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.statement.StatementSummaryData
 */
export const StatementSummaryData = new StatementSummaryData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StatementSummaryData_Activity$Type extends MessageType<StatementSummaryData_Activity> {
    constructor() {
        super("rd.statement.StatementSummaryData.Activity", [
            { no: 1, name: "date", kind: "message", T: () => Timestamp },
            { no: 2, name: "transaction_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "purchase_order_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "charge_amount", kind: "message", T: () => Money },
            { no: 6, name: "credit_amount", kind: "message", T: () => Money },
            { no: 7, name: "outstanding_balance", kind: "message", T: () => Money },
            { no: 8, name: "due_date", kind: "message", T: () => Timestamp },
            { no: 9, name: "job_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StatementSummaryData_Activity>): StatementSummaryData_Activity {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.transactionType = "";
        message.identifier = "";
        message.purchaseOrderName = "";
        message.jobName = "";
        if (value !== undefined)
            reflectionMergePartial<StatementSummaryData_Activity>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StatementSummaryData_Activity): StatementSummaryData_Activity {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp date */ 1:
                    message.date = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.date);
                    break;
                case /* string transaction_type */ 2:
                    message.transactionType = reader.string();
                    break;
                case /* string identifier */ 3:
                    message.identifier = reader.string();
                    break;
                case /* string purchase_order_name */ 4:
                    message.purchaseOrderName = reader.string();
                    break;
                case /* rd.proto.money.Money charge_amount */ 5:
                    message.chargeAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.chargeAmount);
                    break;
                case /* rd.proto.money.Money credit_amount */ 6:
                    message.creditAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.creditAmount);
                    break;
                case /* rd.proto.money.Money outstanding_balance */ 7:
                    message.outstandingBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.outstandingBalance);
                    break;
                case /* google.protobuf.Timestamp due_date */ 8:
                    message.dueDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.dueDate);
                    break;
                case /* string job_name */ 9:
                    message.jobName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StatementSummaryData_Activity, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp date = 1; */
        if (message.date)
            Timestamp.internalBinaryWrite(message.date, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string transaction_type = 2; */
        if (message.transactionType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.transactionType);
        /* string identifier = 3; */
        if (message.identifier !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.identifier);
        /* string purchase_order_name = 4; */
        if (message.purchaseOrderName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.purchaseOrderName);
        /* rd.proto.money.Money charge_amount = 5; */
        if (message.chargeAmount)
            Money.internalBinaryWrite(message.chargeAmount, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money credit_amount = 6; */
        if (message.creditAmount)
            Money.internalBinaryWrite(message.creditAmount, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money outstanding_balance = 7; */
        if (message.outstandingBalance)
            Money.internalBinaryWrite(message.outstandingBalance, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp due_date = 8; */
        if (message.dueDate)
            Timestamp.internalBinaryWrite(message.dueDate, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string job_name = 9; */
        if (message.jobName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.jobName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.statement.StatementSummaryData.Activity
 */
export const StatementSummaryData_Activity = new StatementSummaryData_Activity$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StatementSummaryData_OutstandingInvoice$Type extends MessageType<StatementSummaryData_OutstandingInvoice> {
    constructor() {
        super("rd.statement.StatementSummaryData.OutstandingInvoice", [
            { no: 1, name: "date", kind: "message", T: () => Timestamp },
            { no: 3, name: "purchase_order_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "outstanding_balance", kind: "message", T: () => Money },
            { no: 5, name: "due_date", kind: "message", T: () => Timestamp },
            { no: 6, name: "original_balance", kind: "message", T: () => Money },
            { no: 7, name: "job_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "associated_payments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => StatementSummaryData_OutstandingInvoice_AssociatedPayment },
            { no: 9, name: "transaction_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StatementSummaryData_OutstandingInvoice>): StatementSummaryData_OutstandingInvoice {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.purchaseOrderName = "";
        message.jobName = "";
        message.associatedPayments = [];
        message.transactionType = "";
        message.identifier = "";
        if (value !== undefined)
            reflectionMergePartial<StatementSummaryData_OutstandingInvoice>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StatementSummaryData_OutstandingInvoice): StatementSummaryData_OutstandingInvoice {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp date */ 1:
                    message.date = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.date);
                    break;
                case /* string purchase_order_name */ 3:
                    message.purchaseOrderName = reader.string();
                    break;
                case /* rd.proto.money.Money outstanding_balance */ 4:
                    message.outstandingBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.outstandingBalance);
                    break;
                case /* google.protobuf.Timestamp due_date */ 5:
                    message.dueDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.dueDate);
                    break;
                case /* rd.proto.money.Money original_balance */ 6:
                    message.originalBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.originalBalance);
                    break;
                case /* string job_name */ 7:
                    message.jobName = reader.string();
                    break;
                case /* repeated rd.statement.StatementSummaryData.OutstandingInvoice.AssociatedPayment associated_payments */ 8:
                    message.associatedPayments.push(StatementSummaryData_OutstandingInvoice_AssociatedPayment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string transaction_type */ 9:
                    message.transactionType = reader.string();
                    break;
                case /* string identifier */ 10:
                    message.identifier = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StatementSummaryData_OutstandingInvoice, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp date = 1; */
        if (message.date)
            Timestamp.internalBinaryWrite(message.date, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string purchase_order_name = 3; */
        if (message.purchaseOrderName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.purchaseOrderName);
        /* rd.proto.money.Money outstanding_balance = 4; */
        if (message.outstandingBalance)
            Money.internalBinaryWrite(message.outstandingBalance, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp due_date = 5; */
        if (message.dueDate)
            Timestamp.internalBinaryWrite(message.dueDate, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money original_balance = 6; */
        if (message.originalBalance)
            Money.internalBinaryWrite(message.originalBalance, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string job_name = 7; */
        if (message.jobName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.jobName);
        /* repeated rd.statement.StatementSummaryData.OutstandingInvoice.AssociatedPayment associated_payments = 8; */
        for (let i = 0; i < message.associatedPayments.length; i++)
            StatementSummaryData_OutstandingInvoice_AssociatedPayment.internalBinaryWrite(message.associatedPayments[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string transaction_type = 9; */
        if (message.transactionType !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.transactionType);
        /* string identifier = 10; */
        if (message.identifier !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.identifier);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.statement.StatementSummaryData.OutstandingInvoice
 */
export const StatementSummaryData_OutstandingInvoice = new StatementSummaryData_OutstandingInvoice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StatementSummaryData_OutstandingInvoice_AssociatedPayment$Type extends MessageType<StatementSummaryData_OutstandingInvoice_AssociatedPayment> {
    constructor() {
        super("rd.statement.StatementSummaryData.OutstandingInvoice.AssociatedPayment", [
            { no: 1, name: "date", kind: "message", T: () => Timestamp },
            { no: 2, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "amount", kind: "message", T: () => Money },
            { no: 4, name: "transaction_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<StatementSummaryData_OutstandingInvoice_AssociatedPayment>): StatementSummaryData_OutstandingInvoice_AssociatedPayment {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.transactionType = "";
        if (value !== undefined)
            reflectionMergePartial<StatementSummaryData_OutstandingInvoice_AssociatedPayment>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StatementSummaryData_OutstandingInvoice_AssociatedPayment): StatementSummaryData_OutstandingInvoice_AssociatedPayment {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp date */ 1:
                    message.date = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.date);
                    break;
                case /* string identifier */ 2:
                    message.identifier = reader.string();
                    break;
                case /* rd.proto.money.Money amount */ 3:
                    message.amount = Money.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                case /* string transaction_type */ 4:
                    message.transactionType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StatementSummaryData_OutstandingInvoice_AssociatedPayment, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp date = 1; */
        if (message.date)
            Timestamp.internalBinaryWrite(message.date, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 2; */
        if (message.identifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier);
        /* rd.proto.money.Money amount = 3; */
        if (message.amount)
            Money.internalBinaryWrite(message.amount, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string transaction_type = 4; */
        if (message.transactionType !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.transactionType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.statement.StatementSummaryData.OutstandingInvoice.AssociatedPayment
 */
export const StatementSummaryData_OutstandingInvoice_AssociatedPayment = new StatementSummaryData_OutstandingInvoice_AssociatedPayment$Type();
